import React from "react";
import { motion } from "framer-motion";
import type { Product } from "../types/product";
import { ease } from "../utils/styles";
import { ProductCard } from "./ProductCard";
interface ProductGridProps {
  products: Product[];
  cols?: 3 | 4;
}
export function ProductGrid({
  products,
  cols = 4
}: ProductGridProps) {
  return <ul className={`grid grid-cols-2 gap-x-4 gap-y-10 sm:gap-x-6 md:grid-cols-3 ${cols === 4 ? "lg:grid-cols-4" : "lg:grid-cols-3"}`} data-id="element-355" data-mp="1074jb6jaje7x">
      {products.map((p, i) => <motion.li key={p.id} initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: "-40px"
    }} transition={{
      duration: 0.25,
      delay: i % 4 * 0.04,
      ease
    }} data-id="element-356" data-mp="1svjkap5l7w09" data-mpi={i}>
          <ProductCard product={p} data-id="element-357" data-mp="1j343hv611dgy" />
        </motion.li>)}
    </ul>;
}